import React, { useEffect, useState } from 'react';

interface LoadingSpinnerProps {
    size?: 'sm' | 'md' | 'lg' | 'xl';
    className?: string;
    message?: string;
    decorative?: boolean;
}

const sizeClasses: Record<NonNullable<LoadingSpinnerProps['size']>, string> = {
    sm: 'h-4 w-4 border-2',
    md: 'h-8 w-8 border-2',
    lg: 'h-10 w-10 border-4',
    xl: 'h-12 w-12 border-4',
};

export const LoadingSpinner: React.FC<LoadingSpinnerProps> = ({
    size = 'md',
    className = '',
    message = 'Loading...',
    decorative = false,
}) => {
    const [stagedMessage, setStagedMessage] = useState('');

    useEffect(() => {
        if (decorative) {
            return;
        }
        setStagedMessage(message);
    }, [decorative, message]);

    const spinnerClasses = `${sizeClasses[size]} animate-spin rounded-full border-mp-border border-t-mp-primary`;

    if (decorative) {
        return <div aria-hidden="true" className={`${spinnerClasses} ${className}`} />;
    }

    return (
        <div role="status" aria-live="polite" className={`flex items-center justify-center ${className}`}>
            <div className="text-center">
                <div aria-hidden="true" className={`${spinnerClasses} mx-auto`} />
                <p className="mt-4 min-h-[1lh] text-mp-muted font-heading">{stagedMessage}</p>
            </div>
        </div>
    );
};
